import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import ScrollContainer from "react-indiana-drag-scroll";
import placeholder from "./placeholder.png";
import { animateScroll as scroll, scroller } from "react-scroll";
import { componentDidUpdate } from "react-style-tag/lib/Style";

class index extends Component {
  handleClick = (category) => {
    window.removeEventListener("scroll", this.handleScroll);
    this.props.setSelectedCategory(category);
    let location =
      this.props.categories.findIndex(
        (cat) => cat.id == this.props.selectedCategory.id
      ) > this.props.categories.findIndex((cat) => cat.id == category.id);

    let parent = document.getElementById("categories_header");

    let moveTo = category == "all" ? this.props.categories[0] : category;
    scroller.scrollTo("navigate" + moveTo.id, {
      duration: 500,
      delay: 0,
      behavior: "instant",
      offset: this.offsetAmount(
        document.documentElement.clientWidth > 767
          ? document.getElementById("categories_header").getBoundingClientRect()
              .y !== 0
          : document.getElementById("categories_header").getBoundingClientRect()
              .y !== 54,
        location
      ),

      smooth: true,
    });

    setTimeout(() => {
      window.addEventListener("scroll", this.handleScroll);
    }, 600);
  };

  scrollHeader = (categoryID) => {
    let targetElement;
    const container = document.getElementById("categories-top");
    if (categoryID == "all") {
      targetElement = document.getElementById("header-all");
    } else {
      targetElement = document.getElementById("header-" + categoryID);
    }
    const offsetLeft = targetElement?.offsetLeft - container?.offsetLeft;

    // Optional: center the target in view
    const scrollPosition =
      offsetLeft - container?.clientWidth / 2 + targetElement?.clientWidth / 2;

    container.scrollTo({
      left: scrollPosition,
      behavior: "smooth",
    });
    // if (targetElement && !isVisible) {
    //   targetElement.scrollIntoView({
    //     behavior: "smooth",
    //     block: "nearest",
    //     inline: "center",
    //     delay: 0,
    //     duration: 0,
    //   });
    // }
  };

  componentDidMount() {
    if (this.props.settings.categories_layout_sticky) {
      window.addEventListener("scroll", this.handleScroll);

      if (this.props.selectedCategory !== "all") {
        const targetElement = document.getElementById(
          "header-" + this.props.selectedCategory.id
        );

        if (targetElement) {
          const rect = targetElement.getBoundingClientRect();
          const isVisible = rect.right > 0 && rect.left < window.innerWidth;
          if (!isVisible) {
            this.scrollHeader(this.props.selectedCategory.id);
          }
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.props.settings.categories_layout_sticky) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }

  handleScroll = () => {
    if (this.props.settings.categories_layout_sticky) {
      this.checkVisibleCategories();
    }
  };

  checkVisibleCategories = () => {
    const desktopSize = document.documentElement.clientWidth > 767;
    const phoneSize = document.documentElement.clientWidth <= 767;
    if (
      (desktopSize &&
        document.getElementById("categories_header").getBoundingClientRect()
          .y == 0) ||
      (phoneSize &&
        document.getElementById("categories_header").getBoundingClientRect()
          .y <= 54)
    ) {
      const categories = Array.from(
        document.querySelectorAll('[id^="navigate"]')
      );
      let firstVisibleCategory = null;

      categories.forEach((category) => {
        const rect = category.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 54;

        if (isVisible) {
          if (
            !firstVisibleCategory ||
            rect.top < firstVisibleCategory.rect.top
          ) {
            firstVisibleCategory = {
              id: category.id.replace("navigate", ""),
              rect,
            };
          }
        }
      });

      if (firstVisibleCategory) {
        const category = this.props.categories.find(
          (cat) => cat.id == firstVisibleCategory.id
        );
        this.scrollHeader(category.id);
        this.props.setSelectedCategory(category);
      }
    } else if (this.props.selectedCategory !== "all" && !this.props.isSticky) {
      this.props.setSelectedCategory("all");
      this.scrollHeader("all");
    }
    if (
      this.props.selectedCategory !== "all" &&
      this.props.settings.categories_layout_sticky
    ) {
      const targetElement = document.getElementById(
        "header-" + this.props.selectedCategory.id
      );

      if (targetElement) {
        const rect = targetElement.getBoundingClientRect();
        const isVisible = rect.right > 0 && rect.left < window.innerWidth;
        if (!isVisible) {
          this.scrollHeader(this.props.selectedCategory.id);
        }
      }
    }
  };

  // checkVisibleCategories = () => {
  //   if (
  //     (document.documentElement.clientWidth > 767 &&
  //       document.getElementById("categories_header").getBoundingClientRect()
  //         .y == 0) ||
  //     (document.documentElement.clientWidth <= 767 &&
  //       document.getElementById("categories_header").getBoundingClientRect()
  //         .y <= 54)
  //   ) {
  //     const categories = Array.from(
  //       document.querySelectorAll('[id^="navigate"]')
  //     );
  //     let firstVisibleCategory = null;

  //     categories.forEach((category) => {
  //       const rect = category.getBoundingClientRect();
  //       const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

  //       if (isVisible) {
  //         if (
  //           !firstVisibleCategory ||
  //           rect.top < firstVisibleCategory.rect.top
  //         ) {
  //           firstVisibleCategory = {
  //             id: category.id.replace("navigate", ""),
  //             rect,
  //           };
  //         }
  //       }
  //     });

  //     if (firstVisibleCategory) {
  //       const category = this.props.categories.find(
  //         (cat) => cat.id == firstVisibleCategory.id
  //       );
  //       this.lastVisibleCategory = firstVisibleCategory;
  //       this.scrollHeader(category.id);
  //       this.props.setSelectedCategory(category);
  //     } else if (this.lastVisibleCategory) {
  //       const lastCategory = this.props.categories.find(
  //         (cat) => cat.id == this.lastVisibleCategory.id
  //       );
  //       this.scrollHeader(lastCategory.id);
  //       this.props.setSelectedCategory(lastCategory);
  //     }
  //   } else {
  //     if (this.props.selectedCategory.id == this.props.categories[0]?.id) {
  //       this.props.setSelectedCategory("all");
  //       this.scrollHeader("all");
  //     }
  //   }
  // };

  offsetAmount = (start, location) =>
    !this.props.settings.categories_layout_sticky
      ? document.documentElement.clientWidth > 767
        ? -80
        : -130
      : this.props.categoriesStyle == "bubbles"
      ? document.documentElement.clientWidth > 767
        ? start == true || location
          ? this.props.settings.store_layout == "list" ||
            this.props.settings.store_layout == "jumbo"
            ? -200
            : -150
          : -150
        : start == true || location
        ? this.props.settings.store_layout == "list" ||
          this.props.settings.store_layout == "jumbo"
          ? -260
          : -210
        : -210
      : this.props.categoriesStyle == "labels"
      ? document.documentElement.clientWidth > 767
        ? start == true || location
          ? this.props.settings.store_layout == "list" ||
            this.props.settings.store_layout == "jumbo"
            ? -120
            : -70
          : -70
        : start == true || location
        ? this.props.settings.store_layout == "list" ||
          this.props.settings.store_layout == "jumbo"
          ? -180
          : -130
        : -130
      : this.props.categoriesStyle == "tags"
      ? document.documentElement.clientWidth > 767
        ? start == true || location
          ? this.props.settings.store_layout == "list" ||
            this.props.settings.store_layout == "jumbo"
            ? -170
            : -120
          : -110
        : start == true || location
        ? this.props.settings.store_layout == "list" ||
          this.props.settings.store_layout == "jumbo"
          ? -210
          : -170
        : -160
      : 0;

  render() {
    const {
      categories,
      language,
      settings,
      themeColor,
      categoriesStyle,
      selectedCategory,
    } = this.props;

    return (
      <div
        className="categories_header"
        style={{
          paddingTop:
            categoriesStyle == "bubbles"
              ? 30
              : categoriesStyle == "labels"
              ? 20
              : 30,
          paddingBottom:
            categoriesStyle == "bubbles"
              ? 0
              : categoriesStyle == "labels"
              ? 10
              : 15,
          backgroundColor: "white",
          opacity: 1,
          scrollBehavior: "smooth",
          marginBottom: settings.store_layout == "list-collapse" && 30,
        }}
        id="categories_header"
      >
        <div className="h-100 w-100">
          <div
            style={{
              display: "flex",
              gridTemplateColumns: `repeat(${categories.length + 2}, auto)`,
              gridTemplateRows: 1,
              overflow: "auto",

              height:
                categoriesStyle == "bubbles"
                  ? 120
                  : categoriesStyle == "labels"
                  ? 40
                  : 60,
              paddingRight: 10,
              paddingLeft: 10,

              width: "100%",
              direction: language == "english" ? "ltr" : "rtl",
            }}
            className="disable-scroll-bar w-100"
            id="categories-top"
          >
            {!settings.hide_categories_layout_all && (
              <>
                <div
                  style={{
                    minWidth: 80,
                    marginRight: 8,
                    marginLeft: 8,
                    justifySelf: "center",
                    userSelect: "none",
                    cursor: "pointer",
                    opacity:
                      categoriesStyle == "bubbles" ||
                      categoriesStyle == "labels"
                        ? selectedCategory === "all"
                          ? 1
                          : 0.5
                        : 1,
                  }}
                  onClick={() => {
                    this.handleClick("all");
                  }}
                  id="header-all"
                >
                  {categoriesStyle == "bubbles" && (
                    <img
                      src={
                        (categories[0].photo_thumb ||
                          categories[0].photo_small ||
                          this.props.store?.logo) &&
                        (
                          categories[0].photo_thumb ||
                          categories[0].photo_small ||
                          this.props.store?.logo
                        )?.startsWith("http")
                          ? categories[0].photo_thumb ||
                            categories[0].photo_small ||
                            this.props.store?.logo
                          : placeholder
                      }
                      style={{
                        width: 70,
                        height: 70,
                        borderRadius: "50%",
                        pointerEvents: "none",
                        border:
                          selectedCategory === "all"
                            ? `2px solid ${themeColor}`
                            : "1px solid #cecece",
                        padding: 1,
                        objectFit: "cover",
                      }}
                    />
                  )}

                  {(categoriesStyle == "bubbles" ||
                    categoriesStyle == "labels") && (
                    <p className="mb-0 mt-1 bold" style={{ fontSize: 13 }}>
                      {language == "arabic" ? "الكل" : "All"}
                    </p>
                  )}

                  {categoriesStyle == "tags" && (
                    <div
                      style={{
                        lineHeight: 3,
                        minWidth: 80,
                        maxHeight: 40,
                        textTransform: "none",
                        fontWeight: "bold",
                        boxShadow: "none",
                        borderRadius: 3,
                        padding: 0,
                        opacity:
                          selectedCategory === "all" && settings.dark ? 1 : 0.5,
                        border:
                          selectedCategory === "all" && settings.dark
                            ? settings.dark
                            : "1px solid #666666",

                        backgroundColor:
                          selectedCategory === "all" && settings.dark
                            ? settings.dark
                            : "white",
                        display: "flex",
                        justifyContent: "center",
                        color:
                          selectedCategory === "all" && settings.dark
                            ? "#ffffff"
                            : "black",
                      }}
                    >
                      <p
                        className="mb-0 bold"
                        style={{ fontSize: 13, padding: "10px" }}
                      >
                        {language == "arabic" ? "الكل" : "All"}
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}
            {categories
              .filter((cat) => {
                if (!cat.products?.length && !cat.has_children) return false;
                if (cat.has_children) {
                  const subCats = categories.filter((subcat) =>
                    cat.sub_categories?.includes(subcat.id)
                  );
                  if (!subCats.length) return false;
                }
                return true;
              })
              .map((category) => {
                const isSelected = selectedCategory?.id === category.id;
                const image =
                  category.photo_thumb ||
                  category.photo_small ||
                  category.photo ||
                  this.props.store?.logo;

                return (
                  <>
                    <div
                      style={{
                        minWidth: "max-content",
                        marginRight: 8,
                        marginLeft: 8,
                        justifySelf: "center",
                        userSelect: "none",
                        cursor: "pointer",
                        opacity:
                          categoriesStyle == "bubbles" ||
                          categoriesStyle == "labels"
                            ? isSelected
                              ? 1
                              : 0.5
                            : 1,
                      }}
                      onClick={() => {
                        this.handleClick(category);
                      }}
                      id={"header-" + category.id}
                    >
                      {categoriesStyle == "bubbles" && (
                        <img
                          src={
                            image && image?.startsWith("http")
                              ? image
                              : placeholder
                          }
                          style={{
                            width: 70,
                            height: 70,
                            borderRadius: "50%",
                            pointerEvents: "none",
                            border: isSelected
                              ? `2px solid ${themeColor}`
                              : "1px solid #cecece",
                            padding: 1,
                            objectFit: "cover",
                          }}
                        />
                      )}

                      {(categoriesStyle == "bubbles" ||
                        categoriesStyle == "labels") && (
                        <p className="mb-0 mt-1 bold" style={{ fontSize: 13 }}>
                          {language == "arabic"
                            ? category.ar_name
                            : category.name}
                        </p>
                      )}

                      {categoriesStyle == "tags" && (
                        <div
                          style={{
                            lineHeight: 3,
                            minWidth: 80,
                            maxHeight: 40,
                            textTransform: "none",
                            fontWeight: "bold",
                            boxShadow: "none",
                            borderRadius: 3,
                            padding: 0,
                            opacity: isSelected && settings.dark ? 1 : 0.5,
                            border:
                              isSelected && settings.dark
                                ? settings.dark
                                : "1px solid #666666",

                            backgroundColor:
                              isSelected && settings.dark
                                ? settings.dark
                                : "white",
                            display: "flex",
                            justifyContent: "center",
                            color:
                              isSelected && settings.dark ? "#ffffff" : "black",
                          }}
                        >
                          <p
                            className="mb-0 bold"
                            style={{ fontSize: 13, padding: "10px" }}
                          >
                            {language == "arabic"
                              ? category.ar_name
                              : category.name}
                          </p>
                        </div>
                      )}
                    </div>
                  </>
                );
              })}
            <span style={{ width: 10 }}></span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.store.store.categories,
    selectedCategory: state.selectedCategoryHeader.selectedCategory,
    cart: state.cart,
    branch: state.branch,
    settings: state.store.store.settings,
    language: state.store.language,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedCategory: (category) =>
      dispatch({ type: "SET_SELECTED_CATEGORY", payload: category }),
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(index));
